import React from 'react';
import PropTypes from 'prop-types';
import './index.module.css';

const LoadingPanel = ({
  loading = true,
  message = 'Loading...',
  className = '',
  role = 'alert',
  ...rest
}) => {
  if (!loading) {
    return null;
  }

  const panelClasses = [
    'loading__panel',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={panelClasses} role={role} {...rest}>
      {message}
    </div>
  );
};

LoadingPanel.propTypes = {
  loading: PropTypes.bool,
  message: PropTypes.string,
  className: PropTypes.string,
  role: PropTypes.string
};

export default LoadingPanel;
